export const OVERVIEW_URL = "/overview/";

export const overviewEndpoints = (builder) => ({
    setCookie: builder.mutation({
        query: _ => ({url: `${OVERVIEW_URL}`, method: 'post', body: {}})
    })
})